var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolCalibration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "measure-calibrate",
    transform: "translate(0.500000, 4.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calibrate",
    transform: "translate(0.500000, 11.500000)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "20 6 23 3 20 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 3,
    x2: 22,
    y2: 3,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "3 6 0 3 3 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.25,
    x: 0,
    y: 0,
    width: 24,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 5.5,
    x2: 4.5,
    y2: 3.5,
    id: "Line-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 5.5,
    x2: 7.5,
    y2: 3.5,
    id: "Line-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 5.5,
    x2: 10.5,
    y2: 3.5,
    id: "Line-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 5.5,
    x2: 13.5,
    y2: 3.5,
    id: "Line-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 5.5,
    x2: 16.5,
    y2: 3.5,
    id: "Line-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 5.5,
    x2: 19.5,
    y2: 3.5,
    id: "Line-5",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolCalibration);
export default __webpack_public_path__ + "static/media/tool-calibration.5a41d0cd12e112f6a78ac5d7d795c9b0.svg";
export { ForwardRef as ReactComponent };